<tec-tile [id]="OPERATION_TYPE.OCR"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon">
	<!-- DOCUMENTOS -->
	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_SECTION_TITLE' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_SECTION_DESCRIPTION' | translate">
		<div class="grid grid-i3">
			<tec-card-select
				img="images/dni.png"
				[title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.DNI' | translate"
				[selected]="dniAvailable"
				(selectedChange)="setDocAvailable('dni_available', $event)"
			></tec-card-select>
			<tec-card-select
				img="images/passport.png"
				[title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.PASSPORT' | translate"
				[selected]="passportAvailable"
				(selectedChange)="setDocAvailable('passport_available', $event)"
			></tec-card-select>
			<tec-card-select
				img="images/nie.png"
				[title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.NIE' | translate"
				[selected]="nieAvailable"
				(selectedChange)="setDocAvailable('nie_available', $event)"
			></tec-card-select>
			@if (eudiWalletAllowed) {
				<tec-card-select
					img="images/eudi-wallet.png"
					[title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.EUDI' | translate"
					[selected]="eudiWalletEnabled"
					(selectedChange)="setEudiWalletEnabled($event)"
				></tec-card-select>
			}
		</div>
		@if (dniAvailable) {
			<tec-divider></tec-divider>
			<div>
				{{ ('WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.DNI' | translate).toUpperCase() }}
			</div>
			<ng-container
				*ngTemplateOutlet="ocrDocCountries; context: { typeCtrl: 'dni_type', countriesCtrl: 'dni_countries' }"
			/>
			<tec-item
				[title]="'WORKFLOWS.FORM.OPERATIONS.SCAN_BARCODE_TITLE' | translate"
				[tagImage]="{icon: 'icon-qr', status: 'default'}">
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.SCAN_BARCODE_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-switch formControlName="scan_barcode" size="sm"></tec-switch>
			</tec-item>
			@if (isCompanyCountrySpain() || isSpainAllowedForDni()) {
				<tec-divider />
			}
			@if (isCompanyCountrySpain()) {
				<tec-item
					[title]="'WORKFLOWS.FORM.OPERATIONS.SCHENGEN_UNLIMITED' | translate"
					[tagImage]="{icon: 'icon-map-pin', status: 'default'}">
					<tec-list-detail>
						<span [innerHTML]="'WORKFLOWS.FORM.OPERATIONS.SCHENGEN_UNLIMITED_DESCRIPTION' | translate: { country: getCompanyCountryName() }"></span>
					</tec-list-detail>
					<tec-switch formControlName="is_schengen_unlimited" size="sm"></tec-switch>
				</tec-item>
			}
			@if (isSpainAllowedForDni()) {
				<div>{{ ('WORKFLOWS.FORM.OPERATIONS.MIDNI_SECTION_TITLE' | translate).toUpperCase() }}</div>
				<tec-item-group>
					<tec-item
						[title]="'WORKFLOWS.FORM.OPERATIONS.MIDNI_VALIDATION' | translate"
						[tagImage]="{icon: 'icon-smartphone', status: 'default'}">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.MIDNI_VALIDATION_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="midni_validation_enabled" size="sm"></tec-switch>
					</tec-item>
					@if (showMidniSkipPol) {
						<tec-item
							[title]="'WORKFLOWS.FORM.OPERATIONS.MIDNI_SKIP_POL_TITLE' | translate"
							[tagImage]="{icon: 'icon-shield', status: 'default'}">
							<tec-list-detail>
								<span>{{ 'WORKFLOWS.FORM.OPERATIONS.MIDNI_SKIP_POL_DESCRIPTION' | translate }}</span>
							</tec-list-detail>
							<tec-switch formControlName="skip_pol_when_midni_authenticated" size="sm"></tec-switch>
						</tec-item>
					}
				</tec-item-group>
			}
		}
		@if (passportAvailable) {
			<tec-divider></tec-divider>
			<div>
				{{ ('WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.PASSPORT' | translate).toUpperCase()}}
			</div>
			<ng-container
				*ngTemplateOutlet="ocrDocCountries; context: { typeCtrl: 'passport_type', countriesCtrl: 'passport_countries' }"
			/>
		}

		<ng-template #ocrDocCountries let-typeCtrl="typeCtrl" let-countriesCtrl="countriesCtrl">
			<div class="grid grid-i2">
				<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.ALLOWED_COUNTRIES' | translate">
					<tec-select
						[options]="ocrDocCountryTypeOptions"
						[formControlName]="typeCtrl"
						[placeholder]="'WORKFLOWS.FORM.OPERATIONS.COUNTRIES_PLACEHOLDER' | translate"
					></tec-select>
				</tec-form-group>
				@if (isDocCountryFiltered(typeCtrl)) {
					<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.LIST_COUNTRIES' | translate">
						<tec-select
							[options]="allCountries"
							[formControlName]="countriesCtrl"
							[placeholder]="'WORKFLOWS.FORM.OPERATIONS.COUNTRIES_PLACEHOLDER' | translate"
							multiple
						></tec-select>
					</tec-form-group>
				}
			</div>
		</ng-template>
		@if (dniAvailable || passportAvailable) {
			<tec-divider></tec-divider>
			<tec-item [title]="'WORKFLOWS.FORM.OPERATIONS.GREEN_CARD_TITLE' | translate"
				[tagImage]="{icon: 'icon-card', status: 'default'}">
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.GREEN_CARD_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-switch formControlName="required_check_nie" size="sm"></tec-switch>
			</tec-item>
		}
		@if (showEudiPolBlock) {
			<!-- Figma Admin NIF-960: bloque bajo EUDI Wallet (Requerir / Omitir POL). -->
			<tec-divider></tec-divider>
			<div>{{ ('WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_OPTIONS.EUDI' | translate).toUpperCase() }}</div>
			<tec-item-group>
				<tec-item
					[title]="'WORKFLOWS.FORM.OPERATIONS.EUDI_POL_LABEL' | translate"
					[tagImage]="{img: 'images/workflow-pol-unselect.png', status: 'simple'}">
					<tec-list-detail>
						<span>{{ 'WORKFLOWS.FORM.OPERATIONS.EUDI_POL_DESCRIPTION' | translate }}</span>
					</tec-list-detail>
					<tec-toggle
						[options]="eudiPolOptions"
						formControlName="skip_pol_when_eudi_authenticated"
						[multiple]="false"
						requireSelection
						size="sm"
					/>
				</tec-item>
			</tec-item-group>
		}
	</tec-tile>
	@if (dniAvailable || passportAvailable || nieAvailable || eudiWalletEnabled) {
		<!-- CONFIGURATION -->
		<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.CONFIG' | translate">
			<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.OCR_MODE' | translate">
				<tec-toggle
					[options]="ocrModeOptions"
					formControlName="mode"
					[multiple]="false"
					requireSelection
				></tec-toggle>
			</tec-form-group>
			@if (company?.manual_validation) {
				<tec-divider></tec-divider>
				@if (isActiveCaptureDefault) {
					<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate"
						[description]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_DESCRIPTION' | translate">
						<tec-toggle
							[options]="ocrFallbackOptions"
							formControlName="fallback"
							[multiple]="false"
							requireSelection
						></tec-toggle>
					</tec-form-group>
				}
				@if (
					fallback === 'manual' || mode === 'manual'
				) {
					<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION' | translate"
						[description]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_DESCRIPTION' | translate">
						<tec-toggle
							[options]="ocrFallbackValidationOptions"
							formControlName="fallback_validation"
							[multiple]="false"
							requireSelection
						></tec-toggle>
					</tec-form-group>
					@if (fallbackValidation === 'manual') {
						<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_EMAIL' | translate"
							[description]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_VALIDATION_EMAIL_DESCRIPTION' | translate">
							<tec-textarea formControlName="fallback_emails" placeholder="email@emaill.com, email@mail.com,"></tec-textarea>
						</tec-form-group>
					}
				}
			}
			<tec-divider></tec-divider>
			<div formGroupName="obfuscation">
				<tec-item-group>
					<tec-item
						[title]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_SECTION_TITLE' | translate"
						[tagImage]="{icon: 'icon-eye-off', status: 'default'}">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_SECTION_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch
							formControlName="enabled"
							size="sm"
							(valueChange)="onObfuscationEnabledChange($event)"
						></tec-switch>
						@if (obfuscationEnabled) {
							<div subheader class="grid grid-i2" style="padding: 12px;">
								<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_FIELDS_LABEL' | translate">
									<tec-select
										[options]="obfuscationFieldOptions"
										formControlName="fields"
										[placeholder]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_FIELDS_PLACEHOLDER' | translate"
										multiple
									/>
								</tec-form-group>
								<tec-form-group
									[label]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_KEEP_CLEAR_COPY' | translate"
									[description]="'WORKFLOWS.FORM.OPERATIONS.OBFUSCATION_KEEP_CLEAR_COPY_DESCRIPTION' | translate">
									<tec-switch formControlName="keep_unobfuscated_copy" />
								</tec-form-group>
							</div>
						}
					</tec-item>
				</tec-item-group>
			</div>
		</tec-tile>

		<!-- ANTIFRAUDE -->
		<tec-tile [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL' | translate">
			<ng-container formGroupName="fraud_scoring">
				<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.CONTRAST_OF_INFORMATION' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.CONTRAST_OF_INFORMATION_DESCRIPTION' | translate">
					<tec-list-detail>
						<tec-info-group>
							<tec-toggle
								[options]="[{
									id: 'true',
									label: 'WORKFLOWS.FORM.OPERATIONS.AEAT' | translate,
									tooltip: 'WORKFLOWS.FORM.OPERATIONS.AEAT_TOOLTIP' | translate
								}]"
								formControlName="aeat"
								[multiple]="false"
							></tec-toggle>
							<tec-toggle
								[options]="[{
									id: 'true',
									label: 'WORKFLOWS.FORM.OPERATIONS.AML' | translate,
									tooltip: 'WORKFLOWS.FORM.OPERATIONS.AML_TOOLTIP' | translate
								}]"
								formControlName="aml"
								[multiple]="false"
							></tec-toggle>
							<tec-toggle
								[options]="[{
									id: 'true',
									label: 'WORKFLOWS.FORM.OPERATIONS.PEP' | translate,
									tooltip: 'WORKFLOWS.FORM.OPERATIONS.PEP_TOOLTIP' | translate
								}]"
								formControlName="pep"
								[multiple]="false"
							></tec-toggle>
						</tec-info-group>
					</tec-list-detail>
				</tec-form-group>
				<tec-divider></tec-divider>
				<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL' | translate"
					[description]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL_DESCRIPTION' | translate">
					<tec-toggle
						[options]="[
							{ id: DEMAND_LEVEL.RECOMMENDED, label: 'WORKFLOWS.FORM.OPERATIONS.RECOMMENDED' | translate },
							{ id: DEMAND_LEVEL.CUSTOM, label: 'WORKFLOWS.FORM.OPERATIONS.CUSTOM' | translate }
						]"
						formControlName="type"
						[multiple]="false"
						requireSelection
					></tec-toggle>
				</tec-form-group>
			<!-- RECOMENDADO -->
			@if (fraudDemandType === DEMAND_LEVEL.RECOMMENDED) {
				<tec-tile [subtitle]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL_SUBTITLE' | translate">
					<div class="grid grid-i3">
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.PHOTOCOPY' | translate">
							<tec-tag [label]="'BUTTON.BLOCK' | translate" status="warning"></tec-tag>
						</tec-info-group>
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.PHOTO' | translate">
							<tec-tag [label]="'BUTTON.BLOCK' | translate" status="warning"></tec-tag>
						</tec-info-group>
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.MANIPULADTED_IMAGE' | translate">
							<tec-tag [label]="'BUTTON.BLOCK' | translate" status="warning"></tec-tag>
						</tec-info-group>
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate">
							<tec-badge [label]="'2'" type="square"></tec-badge>
							<tec-tooltip [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate" position="right">
								<tec-icon name="icon-info"></tec-icon>
							</tec-tooltip>
						</tec-info-group>
						<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.MAX_TIME_SIDE' | translate">
							<span>150s</span>
							<tec-tooltip [label]="'WORKFLOWS.FORM.OPERATIONS.MAX_TIME_SIDE_TOOLTIP' | translate" position="right">
								<tec-icon name="icon-info"></tec-icon>
							</tec-tooltip>
						</tec-info-group>
					</div>
					<tec-link
						[label]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate"
						(click)="openOcrFraudModal()"
					></tec-link>
				</tec-tile>
			}
			</ng-container>
			<!-- CUSTOM -->
			@if (fraudDemandType === DEMAND_LEVEL.CUSTOM) {
				<tec-tile [subtitle]="'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL_CUSTOM_SUBTITLE' | translate">
					<div class="grid grid-i3">
						<ng-container formGroupName="fraud_scoring">
							<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.PHOTOCOPY' | translate"
								formGroupName="photocopy_check">
								<tec-switch formControlName="available"></tec-switch>
							</tec-info-group>
							<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.PHOTO' | translate"
								formGroupName="screen_photo">
								<tec-switch formControlName="available"></tec-switch>
							</tec-info-group>
							<tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.MANIPULADTED_IMAGE' | translate"
								formGroupName="manipulated_photo">
								<tec-switch formControlName="available"></tec-switch>
							</tec-info-group>
						</ng-container>
						<ng-container formGroupName="setting">
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate"
								[errorMsg]="reactiveFormService.hasMsgError(group.get('setting.total_tries'))">
								<tec-input-quantity
									[min]="1"
									[max]="4"
									[step]="1"
									formControlName="total_tries"
									[hasError]="reactiveFormService.hasError(group.get('setting.total_tries'))"
								></tec-input-quantity>
							</tec-form-group>
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.MAX_TIME_SIDE' | translate"
								[errorMsg]="reactiveFormService.hasMsgError(group.get('setting.side_max_time'))">
								<tec-input
									type="number"
									formControlName="side_max_time"
									[hasError]="reactiveFormService.hasError(group.get('setting.side_max_time'))"
								></tec-input>
							</tec-form-group>
						</ng-container>
					</div>
					@if (hasCustomFraudChecks) {
						<tec-link
							[label]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate"
							(click)="openOcrFraudModal()"
						></tec-link>
					}
				</tec-tile>
			}
		</tec-tile>

		<!-- CONFIGURACION AVANZADA -->
		<app-workflow-form-advanced-collapse [expanded]="id">
			<div class="item-group">
				<ng-container formGroupName="fraud_scoring">
					<span>{{ ('WORKFLOWS.FORM.OPERATIONS.REQUIREMENTS' | translate).toUpperCase() }}</span>
					<tec-item [classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.LEGAL_AGE' | translate"
						[tagImage]="{icon: 'icon-list-ticks'}"
						[clickeable]="false">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.LEGAL_AGE_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-input
							type="number"
							formControlName="legal_age"
							[hasError]="reactiveFormService.hasError(group.get('fraud_scoring.legal_age'))"
						></tec-input>
					</tec-item>
					<tec-divider></tec-divider>
					<tec-item [classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.COUNTRY' | translate"
						[tagImage]="{icon: 'icon-list-ticks'}"
						[clickeable]="false">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.COUNTRY_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="valid_country" size="sm"></tec-switch>
					</tec-item>
					<tec-divider></tec-divider>
					<tec-item [classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENT_EXPIRED' | translate"
						[tagImage]="{icon: 'icon-list-ticks'}"
						[clickeable]="false">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCUMENT_EXPIRED_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="expirated" size="sm"></tec-switch>
					</tec-item>
					@if (showAllowedDaysExpired) {
						<tec-divider></tec-divider>
						<tec-item [classes]="['item--outline']"
							[title]="'WORKFLOWS.FORM.OPERATIONS.ALLOWED_DAYS_EXPIRED' | translate"
							[tagImage]="{icon: 'icon-list-ticks'}"
							[clickeable]="false">
							<tec-list-detail>
								<span>{{ 'WORKFLOWS.FORM.OPERATIONS.ALLOWED_DAYS_EXPIRED_DESCRIPTION' | translate }}</span>
							</tec-list-detail>
							<tec-input
								type="number"
								formControlName="ocr_allowed_expiration"
								[hasError]="reactiveFormService.hasError(group.get('fraud_scoring.ocr_allowed_expiration'))"
								[min]="0"
								[max]="7"
							></tec-input>
						</tec-item>
					}
					<tec-divider />
					<tec-item
						[classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.VALIDATE_ADDRESS' | translate"
						[tagImage]="{icon: 'icon-list-ticks'}"
						[clickeable]="false"
					>
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.VALIDATE_ADDRESS_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="validate_address" size="sm" />
					</tec-item>
					<tec-divider />
					<tec-item
						[classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.VALIDATE_TEAM_NUMBER' | translate"
						[tagImage]="{icon: 'icon-list-ticks'}"
						[clickeable]="false"
					>
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.VALIDATE_TEAM_NUMBER_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="validate_team_number" size="sm" />
					</tec-item>
				</ng-container>

				<ng-container>
					<span>{{ ('WORKFLOWS.FORM.OPERATIONS.INTERFACE_AND_ASSISTANCE' | translate).toUpperCase() }}</span>
					<tec-item [classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
						[tagImage]="{icon: 'icon-AI'}"
						[clickeable]="false">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="tutorial" size="sm"></tec-switch>
					</tec-item>
					<tec-divider></tec-divider>
					<tec-item [classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.ANIMATIONS' | translate"
						[tagImage]="{icon: 'icon-AI'}"
						[clickeable]="false">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.ANIMATIONS_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="animations" size="sm"></tec-switch>
					</tec-item>
					<tec-divider></tec-divider>
					<tec-item [classes]="['item--outline']"
						[title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENT_WATERMARK' | translate"
						[tagImage]="{icon: 'icon-card'}"
						[clickeable]="false">
						<tec-list-detail>
							<span>{{ 'WORKFLOWS.FORM.OPERATIONS.DOCUMENT_WATERMARK_DESCRIPTION' | translate }}</span>
						</tec-list-detail>
						<tec-switch formControlName="document_watermark" size="sm"></tec-switch>
					</tec-item>
				</ng-container>
			</div>
		</app-workflow-form-advanced-collapse>
	}
</tec-tile>
